var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-editor',{attrs:{"initialFetchAsync":_vm.fetchSettings,"saveAsync":_vm.saveSettings}})}
var staticRenderFns = []

export { render, staticRenderFns }